import styled from "@emotion/styled";
import { MOBILE_QUERY_MAX_WIDTH, TABLET_QUERY_MAX_WIDTH } from "constants/vp-sizes";
export const StyledHotdogHeaderComponent = styled.div`
  position: relative;
  width: 100vw;

  .hotdog {
    content: "";
    width: 132vw;
    height: 132vw;
    position: absolute;
    bottom: 0;
    left: -16vw;
    z-index: 0;
    border-radius: 50%;

    @media (max-width: ${TABLET_QUERY_MAX_WIDTH}) {
      width: 136vw;
      height: 136vw;
      left: -18vw;
    }

    @media (max-width: ${MOBILE_QUERY_MAX_WIDTH}) {
      width: 220vw;
      height: 220vw;
      left: -60vw;
    }
  }
`;
